"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var PropTypes = require("prop-types");
var React = require("react");
var I18n = require("i18n-js");
var ProductPreview = /** @class */ (function (_super) {
    tslib_1.__extends(ProductPreview, _super);
    function ProductPreview(props) {
        var _this = _super.call(this, props) || this;
        _this.handleClick = _this.handleClick.bind(_this);
        return _this;
    }
    ProductPreview.prototype.handleClick = function () {
        return this.props.handleClick(this.props.product);
    };
    ProductPreview.prototype.render = function () {
        return (React.createElement("div", { className: "product-preview", onClick: this.handleClick, key: this.props.product.id },
            React.createElement("div", { className: "product-preview__thumbnail" },
                React.createElement("img", { alt: this.props.product.title, src: this.props.product._links.photo.href })),
            React.createElement("div", { className: "product-preview__content" },
                React.createElement("h4", { className: "product-preview__title" }, this.props.product.title),
                this.props.product.sku &&
                    React.createElement("div", { className: "product-preview__sku" }, I18n.t('discovery.productSearchForm.productDetails.sku', { sku: this.props.product.sku })),
                this.props.product.condition &&
                    React.createElement("div", { className: "product-preview__condition" }, I18n.t('discovery.productSearchForm.productDetails.condition', {
                        condition: this.props.product.condition.display_name,
                    })),
                this.props.product.seller_cost &&
                    React.createElement("p", { className: "product-preview__cost" }, I18n.t('discovery.productSearchForm.productDetails.sellerCost', {
                        cost: this.props.product.seller_cost.display,
                    }))),
            React.createElement("span", { className: "product-preview__price" }, this.props.product.price.display)));
    };
    return ProductPreview;
}(React.Component));
ProductPreview.propTypes = {
    product: PropTypes.object.isRequired,
    handleClick: PropTypes.func,
};
exports.default = ProductPreview;
//# sourceMappingURL=product_preview.js.map


//////////////////
// WEBPACK FOOTER
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/discovery-ui/dist/components/product_search_form/product_preview.js
// module id = aXJE
// module chunks = 20 21